import React from 'react';
import NextUpActionsDialog
  from './Components/NextUpActionsDialog';
import {
  NextUpContextProvider,
} from './Components/NextUpContext';

const Layout = () => {
  return (
    <NextUpContextProvider>
      <NextUpActionsDialog />
    </NextUpContextProvider>
  );
};

export default Layout;
